import {Home} from '@/layout'

export default {
    path: '/exam',
    component: Home,
    meta: {
        roles: ['user', 'teacher'],
        childrenRoles: false
    },
    children: [
        {
            path: '',
            meta: {
                title: '等级考试'
            },
            component: () => import('@/page/exam')
        },
        {
            path: ':exid',
            props: (router) => ({exid: router.params.exid, mexid: router.query.mexid}),
            meta: {
                title: '等级考试'
            },
            component: () => import('@/page/exam/TestPaper')
        },
    ]
}